<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .outcome {
    @include colors.color("textWhite");
    height: utils.in_rem(26px);
    white-space: nowrap;
    @include mixins.body3;
    padding: utils.in_rem(6px) utils.in_rem(8px);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.noAnswer {
      background-color: colors.get("primary_30");
    }
    &.voicemail {
      background-color: colors.get("primary_70");
    }
    &.callBackLater {
      background-color: colors.get("primary_50");
    }
    &.interested {
      background-color: colors.get("activityReply_50");
    }
    &.booked {
      background-color: colors.get("activityCalls_50");
    }
    &.notInterested {
      background-color: colors.get("interfaceTransparentBlack_30");
    }
    &.noOutcome {
      background-color: colors.get("interfaceSwGrey_20");
    }
  }
</style>

<script>
  let { call, skeleton = false } = $props();

  let outcomeId = $derived(call?.outcomeId || "noOutcome");

  const outcomeTextMap = {
    noAnswer: "No Answer",
    voicemail: "Voicemail",
    callBackLater: "Call back later",
    interested: "Interested",
    booked: "Meeting Scheduled",
    notInterested: "Not interested",
    noOutcome: "No Outcome",
  };

  let outcomeText = $derived(outcomeTextMap[outcomeId] || "");
</script>

{#if skeleton}
  <span class:skeleton>Loading...</span>
{:else}
  <span class="outcome {outcomeId}" class:skeleton>{outcomeText}</span>
{/if}
